module.exports = __webpack_public_path__ + "img/micrositeVideoPoster.8b118ffe.png";